import React, { Component } from 'react';
import ReactDOM from 'react-dom';
// import scriptLoader from 'react-async-script-loader';
import PropTypes from 'prop-types';
import { PaymentAPI } from 'services/PaymentService.jsx';
import paypal from 'paypal-checkout';
// import circularJson from 'circular-json';

import Log from 'services/Log.jsx';
import { PROD } from "services/ConfigService.jsx";

const ReactButton = paypal.Button.driver('react', { React, ReactDOM });

class PaypalButton extends Component {

  constructor(props) {
        super(props);
        window.React = React;
        window.ReactDOM = ReactDOM;
        this.state = {
            showButton: false,
            uid: this.props.uid
        }
    }

    componentWillReceiveProps ({ isScriptLoaded, isScriptLoadSucceed }) {
    if (!this.state.show) {
      if (isScriptLoaded && !this.props.isScriptLoaded) { // load finished
        if (isScriptLoadSucceed) {
          this.setState({ showButton: true })
          Log.debug('alehop!!', paypal.Button.react)
        }
        else this.props.onError()
      }
    }
  }

  componentDidMount () {
    const { isScriptLoaded, isScriptLoadSucceed } = this.props
    if (isScriptLoaded && isScriptLoadSucceed) {
      this.setState({ showButton: true })
    }
  }

  componentWillUnmount() {
    delete window.React
    delete window.ReactDOM
  }

  render() {
    let payment = (uid, self) => {
      // Log.debug("payment uid: " + circularJson.stringify(uid));
      Log.debug(uid);
      return new paypal.Promise(function(resolve, reject) {

                // Make an ajax call to get the Payment ID. This should call your back-end,
                // which should invoke the PayPal Payment Create api to retrieve the Payment ID.

                // When you have a Payment ID, you need to call the `resolve` method, e.g `resolve(data.paymentID)`
                // Or, if you have an error from your server side, you need to call `reject`, e.g. `reject(err)`
                Log.debug("button uid: " + this.state.uid);

                PaymentAPI.createBillingAgreement({data: this.state.uid}, (response) => {
                    Log.debug(JSON.stringify(response));
                    this.loading = false;
                    if (response.success) {
                      resolve(response.data.token);
                        // this.setState({billingAgreement: response.data});
                    } else {
                      reject("error?");
                    }
                }, (err) => {
                  Log.debug("paypal errored");
                  reject();
                });
                // .post('/my-api/create-payment')
                //     .done(function(data) { resolve(data.paymentID); })
                //     .fail(function(err)  { reject(err); });
            }.bind(this));
    };

    let onAuthorize = (data, actions) => {
      Log.debug("yay");
      Log.debug(data);
      Log.debug(actions);
      this.props.authorized(data, actions);
    };

    Log.debug(this.props);

    let ppbtn = '';
    // const pButton = paypal.Button.driver('react', { React, ReactDOM });
    // if (this.state.showButton) {
        ppbtn = <paypal.Button.react
            env={this.props.env}
            client={this.props.client}
            style={this.props.style}
            payment={payment.bind(this.props.uid, this)}
            commit={true}
            uid={this.props.uid}
            onAuthorize={onAuthorize}
            onCancel={this.props.onCancel}

            // "Error: Unrecognized prop: shipping" was caused by the next line
            // shipping={this.props.shipping}
        />
    // }
    return <div>{ppbtn}</div>;
  }
}

PaypalButton.propTypes = {
    uid: PropTypes.string.isRequired,
    // currency: PropTypes.string.isRequired,
    // total: PropTypes.number.isRequired,
    client: PropTypes.object.isRequired,
    style: PropTypes.object
}

PaypalButton.defaultProps = {
    env: PROD ? 'production' : 'sandbox',
    // null means buyer address is returned in the payment execution response
    shipping: null,
    onSuccess: (payment) => {
        Log.debug('The payment was succeeded!', payment);
    },
    onCancel: (data) => {
        Log.debug('The payment was cancelled!', data)
    },
    onError: (err) => {
        Log.debug('Error loading Paypal script!', err)
    }
};

// export default scriptLoader('https://www.paypalobjects.com/api/checkout.js')(PaypalButton);
export default PaypalButton;



// WEBPACK FOOTER //
// ./src/elements/Paypal/PaypalButton.jsx